// src/auth/index.js
import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import Logout from './Logout';
import Login from './Login';

export default function AuthPage() {
  return (
    <Routes>
      {/* Route cụ thể */}
      <Route path="login" element={<Login />} />
      <Route path="logout" element={<Logout />} />

      {/* Redirect mặc định nếu truy cập /auth */}
      <Route path="*" element={<Navigate to="login" replace />} />
    </Routes>
  );
}